import React, { useEffect, useRef, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton, CFormInput, CFormCheck, CInputGroup, CInputGroupText } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData } from 'react-router-dom';
import axios from "axios";
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { confirmAlert } from 'react-confirm-alert';
import PermissionsNoPage, { Permissions } from "src/components/Permissions";
import AxiosInstance from 'src/components/Axios';
import Status from 'src/components/tableElements/Status';
import CustomPagination from 'src/components/pagination/CustomPaginatiion';
import ItemControlModal from 'src/components/item_control_modal/ItemControlModal';
import styles from '../../components/item_control_modal/ItemControlModal.module.scss'
import ItemControlModalCustom from 'src/components/item_control_modal/ItemControlModalCustom';
import { getDescription } from 'src/store';

const tokenStr = localStorage.getItem('user');
const header = { headers: { "Authorization": `Bearer ${tokenStr}` } };
const user = localStorage.getItem('user_data');

const page = 1;
const postPerPage = 0;
const pageSize = 20;

export async function LoaderPages({ params }) {
  let prm = { page: 1 };

  if (params.type != undefined) {
    prm['type'] = params.type;
  }

  // Запит без фільтрації по language
  let res = await AxiosInstance.get('/pages', { params: prm }).then((response) => {
    response['type'] = (params.type != undefined) ? params.type : "page";
    console.log(response);
    return response;
  });

  if (res.type == undefined) {
    res['type'] = (params.type != undefined) ? params.type : "page";
  }

  // Фільтрація на клієнтській стороні - тільки ua або null мова
  res.data['hydra:member'] = res.data['hydra:member'].filter(page =>
    page.language === null || page.language.id === 1
  );

  return res;
};

const Pages = ({ user_data }) => {
  if (!Permissions(user_data, 'Pages', 'VIEW_PAGES')) {
    return <PermissionsNoPage />;
  }
  const { data, type } = useLoaderData();
  const [rows, setRows] = useState(false);
  const [rowCountState, setRowCountState] = React.useState(0);
  // стан для модалки видалення і приховування
  const [showItemControlModal, setShowItemControlModal] = useState(false);

  //актуальна сторінка
  const [currentPage, setCurrentPage] = useState(1);

  //Чи показувати кнопки видалення і приховування в попапі
  const isDelAction = true;

  // реф для батька модалки
  const containerRef = useRef(null);

  //для чекбокса
  const [selectedIds, setSelectedIds] = useState([]);



  if (!rows) {
    setRowCountState(data['hydra:totalItems'])
    setRows(data['hydra:member']);
  };

  //ефект для відкриття модалки
  useEffect(() => {
    if (selectedIds.length >= 2) {
      setShowItemControlModal(true)
    }
    else {
      setShowItemControlModal(false)
    }
  }, [selectedIds])


  const getRowsTable = (p = 1) => {
    let prm = { page: p };
    if (type != 'page')
      prm['type'] = type;

    AxiosInstance.get('/pages', { params: prm }).then((response) => {
      // Фільтрація на клієнтській стороні для обробки null
      const filteredRows = response.data['hydra:member'].filter(page =>
        page.language === null || page.language.id === 1
      );
      setRows(filteredRows);
    });
  };

  const handlePageChange = (page) => {
    //
    setCurrentPage(page + 1);
    //
    getRowsTable(page + 1);
  };

  function handleSearch(event) {
    axios.get(process.env.REACT_APP_SERVER_URL + '/api/pages?name=' + event.target.value, header).then((response) => {
      //
      const filtered = response.data['hydra:member'].filter(page =>
        page.language === null || page.language.id === 1
      );

      //
      // setRows(response.data['hydra:member']);
      setRows(filtered)
    });
  }

  //обробник для чекбокса 
  const handleCheckboxToggle = (id) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  // function changeVisibilityOfItems(rows, selectedIds) {
  //   confirmAlert({
  //     title: 'Ви впевнені що хочете змінити видимість сторінок ?',
  //     message: '',
  //     buttons: [
  //       {
  //         label: 'Так',
  //         onClick: () => {
  //           console.log('changeVisibility')
  //           const resultItems = selectedIds.map(selectedId => {

  //             return AxiosInstance.put(`/pages/${selectedId}`, { show: rows.find(row => row.id === selectedId)?.show !== undefined ? !rows.find(row => row.id === selectedId)?.show : false })
  //           })

  //           Promise.all(resultItems).then(() => {
  //             getRowsTable()
  //             setSelectedIds([])
  //           })


  //         }
  //       },
  //       {
  //         label: 'Ні',
  //         onClick: () => {
  //           return;
  //         }
  //       }
  //     ]
  //   });
  // }
  function changeVisibilityOfItems(selectedIds) {
    confirmAlert({
      title: 'Ви впевнені що хочете змінити видимість сторінок ?',
      message: '',
      buttons: [
        {
          label: 'Так',
          onClick: async () => {
            try {
              const fetchedObjects = await Promise.all(
                selectedIds.map(id =>
                  AxiosInstance.get(`/pages/${id}`).then(res => res.data)
                )
              );

              const updateRequests = fetchedObjects.map(obj =>
                AxiosInstance.put(`/pages/${obj.id}`, {
                  show: obj.show !== undefined ? !obj.show : false,
                })
              );


              await Promise.all(updateRequests);


              getRowsTable(currentPage);
              setSelectedIds([]);
            } catch (error) {
              console.error('Помилка при оновленні видимості:', error);
            }
          },
        },
        {
          label: 'Ні',
          onClick: () => { },
        },
      ],
    });
  }


  function deleteItems(selectedIds) {
    confirmAlert({
      title: 'Ви впевнені що хочете видалити сторінки ?',
      message: '',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            console.log('delete')
            const resultItems = selectedIds.map(selectedId => {

              return AxiosInstance.delete(`/pages/${selectedId}`)
            })

            Promise.all(resultItems).then(() => {
              getRowsTable(currentPage)
              setSelectedIds([])
            })


          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  }

  function Hidden(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите змінити пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            axios.put(process.env.REACT_APP_SERVER_URL + '/api/pages/' + row.id, { show: row.show !== undefined ? !row.show : false }, header)
              .then(() => {
                getRowsTable(currentPage);
              });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  function Deleted(row) {
    confirmAlert({
      title: 'Ви впевнені що хочите видалити цей пункт ?',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Так',
          onClick: () => {
            const response = axios.delete(process.env.REACT_APP_SERVER_URL + '/api/pages/' + row.id, header).then((response) => {
              getRowsTable(currentPage);
            });
          }
        },
        {
          label: 'Ні',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      sortable: false,
      disableColumnMenu: true,
      width: 70
    },
    {
      field: 'name',
      headerName: 'Назва',
      width: 300,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isChecked = selectedIds.includes(params.row.id);

        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => handleCheckboxToggle(params.row.id)}
              style={{
                accentColor: isChecked ? '#227965' : '#ccc',
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
            />
            {params.row.name}
          </div>
        );
      }
    },
    {
      field: 'content',
      headerName: 'Опис',
      sortable: false,
      disableColumnMenu: true,
      width: 400,
      renderCell: (params) => {
        return <>{getDescription(params.row.content)}</>
      }
    },
    // {
    //   field: 'showStatus',
    //   headerName: 'Status',
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   width: 100,
    //   renderCell: (params) => {
    //     return <Status type={params.row.show ? 'visible' : 'hidden'} />
    //   }
    // },
    {
      field: 'created_at',
      headerName: 'Дата',
      type: 'date',
      width: 160,
      sortable: false,
      disableColumnMenu: true,
    },

    {
      field: "show",
      headerName: "",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      renderCell: (params) => {
        return <button disabled={!Permissions(user, 'Pages', 'HIDE_PAGES')} className='transparent' onClick={() => Hidden(params.row)}>
          {params.row.show ? <img src="/show.svg" alt="show" /> : <img src="/hidden.svg" alt="hidden" />}
        </button>
      }
    },
    {
      field: "action",
      headerName: "Action",
      headerClassName: "hide-header",
      align: 'center',
      width: 70,
      sortable: false,
      // renderCell: (params) => {
      //   return <Link to={'/site-pages/update/' + params.row.id}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
      // }
      renderCell: (params) => {
        return <Link to={'/site-pages/update/' + params.row.id}><img src="/edit.svg" alt="edit" /></Link>;
      }
    },
    {
      field: "delete",
      headerName: "Видалити",
      sortable: false,
      align: 'center',
      width: 70,
      headerClassName: "hide-header",
      // renderCell: (params) => {
      //   return <CButton color="danger" variant="outline" onClick={() => {
      //     Deleted(params.row)
      //   }
      //   }><CIcon icon={cilTrash} customClassName="nav-icon" height={20} /></CButton>;
      // }
      renderCell: (params) => {
        return <button className='transparent' onClick={() => Deleted(params.row)}><img src="/delete.svg" alt="delete" /></button>
      }
    },
  ];

  // console.log('selectedIds', selectedIds)
  // console.log('rows', rows)

  return (
    <CRow>
      <CCol xs={12}>
        <CCard className="mb-4 mt-4">
          <CCardHeader className='items_card_header'>
            {/* <strong> */}
            {/* Сторінки */}
            Pages
            {/* </strong> */}
            <small></small>
          </CCardHeader>
          <CCardBody>
            <div className='head_items_wrapper'>
              <p className="text-medium-emphasis small" style={{ order: '2' }}>
                {
                  (type != undefined && type != 'page') ?
                    <Link to={`/p/${type}/create`} className='link_add_button' ><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                      {/* Створити */}
                      Add
                    </CButton></Link>
                    :
                    <Link to="/site-pages/create" className='link_add_button'><CButton className='item_add_button' color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />
                      {/* Створити */}
                      Add
                    </CButton></Link>
                }
              </p>
              <CInputGroup className="mb-3 item_add_input_wrapper"
              // style={{ border: '1px solid #ccc', height: '40px', width: '228px', borderRadius: "12px" }}
              >
                <CInputGroupText style={{ backgroundColor: 'transparent', border: 'none', padding: 0, paddingLeft: '10px' }}>
                  {/* <CIcon icon={cilSearch} /> */}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                      stroke="#767781"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </CInputGroupText>
                <CFormInput
                  className="item_add_input"
                  type="search"
                  placeholder="Search"
                  onChange={handleSearch}
                />
              </CInputGroup>
            </div>
            <div
              // className='pages_modal_parent'
              style={{ height: 600, width: '100%', position: 'relative' }}
              ref={containerRef}
            >
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={30}
                rowsPerPageOptions={[30]}
                pagination
                rowCount={rowCountState}
                paginationMode="server"
                onPageChange={handlePageChange}

                components={{ Pagination: CustomPagination }}
                headerHeight={44}
                getRowClassName={(params) =>
                  selectedIds.includes(params.row.id) ? 'active-row' : ''
                }
                sx={{
                  borderRadius: '12px',
                  border: '1px solid #ccc',

                  '& .MuiDataGrid-main': {
                    // borderRadius: '12px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                    fontSize: '12px',
                    lineheight: '150%',
                    color: '#717680',
                    //   borderBottom: '2px solid #4e73df',

                  },
                  '& .MuiDataGrid-cell': {
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: '#434349',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    // borderBottomLeftRadius: '12px',
                    // borderBottomRightRadius: '12px',
                  },
                }}


              />

              <ItemControlModalCustom
                show={showItemControlModal}
                setShow={setShowItemControlModal}
                setSelectedIds={setSelectedIds}
                changeVisibilityOfItems={changeVisibilityOfItems}
                deleteItems={deleteItems}
                selectedIds={selectedIds}
                rows={rows}
                isDelAction={isDelAction}

              />

            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default Pages;